"use strict";
/**
 *
 * @param firestore Instancia de Firestore
 * @param providerUid Id del medico
 * @param queryOptions
 * @returns
 */
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const react_query_1 = require("react-query");
function useGetLicences(providerUid, firestore) {
    return (0, react_query_1.useQuery)([], async () => {
        const licensesRef = (0, firestore_1.collection)(firestore, `providers/${providerUid}/licenses`);
        const queryLicenses = (0, firestore_1.query)(licensesRef);
        return queryLicenses;
    });
}
exports.default = useGetLicences;
